import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';

@Component({
    selector: 'app-move-to',
    templateUrl: './move-modal.component.html',
    styleUrls: ['./move-modal.component.css']
})
export class MoveModalComponent {

    @ViewChild('moveBtn') private moveBtn: ElementRef;
    @ViewChild('moveCloseBtn') private moveCloseBtn: ElementRef;

    _folderId;
    number;
    newParent: number;
    currentInode;

    @Input() startInode;
    @Input() disabled;
    @Output() onNewParent = new EventEmitter<number>();

    @Input()
    set folderId(id: number) {
        this._folderId = id;
        this.updateCurrentInode();
    }

    constructor() {
    }

    updateCurrentInode() {
        this.currentInode = this.startInode;
        if (!Number.isNaN(this._folderId)) {
            const inode = this.searchCurrentInode(this.startInode, this._folderId);
            if (inode !== undefined) {
                this.currentInode = inode;
            }
        }
        this.newParent = this.currentInode.id;
    }

    searchCurrentInode(inode, id) {
        if (inode.id === id) {
            return inode;
        }
        for (const child of inode.children) {
            if (child.id === id) {
                return child;
            }
            const childInode = this.searchCurrentInode(child, id);
            if (childInode) {
                return childInode;
            }
        }
        return undefined;
    }

    move() {
        this.onNewParent.emit(this.newParent);
    }

    open() {
        this.updateCurrentInode();
        this.moveBtn.nativeElement.click();
    }

    close() {
        this.moveCloseBtn.nativeElement.click();
    }

    clickFolder(child) {
        if (this.newParent === child.id) {
            this.currentInode = child;
        } else {
            this.newParent = child.id;
        }
    }

    clickUp() {
        this.currentInode = this.currentInode.parent;
        this.newParent = this.currentInode.id;
    }

    inCurrentParent() {
        return this.newParent === this._folderId || (this.newParent === null && Number.isNaN(this._folderId));
    }
}



// WEBPACK FOOTER //
// ./src/app/folder/move-modal/move-modal.component.ts